import { useEffect } from 'react';
import * as gtag from '@/common/utils/gtags.client';

interface GTMEvent {
  event_name: string;
  condition?: boolean;
}

/**
 * If you want a variable to be accessible in gtm when you trigger an event,
 * gtag.pushData with the relevant info must occur before this event is triggered.
 */
export function useSendGTMEvent(event: GTMEvent): void {
  const { event_name, condition } = event;
  useEffect(() => {
    if (condition === undefined || condition) {
      gtag.event(event_name);
    }
  }, [event_name, condition]);
}
